/* eslint-disable indent */
import React, { FC, useContext, useEffect, useState } from "react";
import ArenaTable, { TDrawer } from "components/tableComponents/arenaTable";
import ArenaContext from "contexts/arenas";
import ArenaDrawerGroup from "components/drawers/arena/arenaDrawerGroup";
import TopBar from "components/tableComponents/topBar";
import { LocalizeText } from "components/localizer";
import Banner from "components/banner";
import { usePaginationStore } from "utils/usePaginationStore";
import { useParams } from "react-router-dom";
import { MembershipsContext } from "contexts/memberships";
import VKButton from "components/vkButton";
import { List, ListItemText } from "@mui/material";
import ConfirmDialog from "components/confirmDialog";

const ArenaView: FC = () => {
    const { membership, isFetchingMembership, fetchMembership } = useContext(MembershipsContext);
    const { membershipId } = useParams<{ membershipId: string }>();
    const { getBariumRequestMoreArenasURL } = useContext(ArenaContext);
    const pagination = usePaginationStore("arenas", undefined, { membership_id: membershipId });

    const [selectedArenaId, setSelectedArenaId] = useState<string | undefined>(undefined);
    const [drawerType, setDrawerType] = useState<TDrawer | "">("");
    const [showExternalLinkModal, setShowExternalLinkModal] = useState<"SHOW_MODAL" | "LOADING" | "NONE">("NONE");

    const selectedArena = pagination.results.find((item) => item.uuid === selectedArenaId);

    useEffect(() => {
        if (!membership && !isFetchingMembership && membershipId) {
            fetchMembership(parseInt(membershipId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [membershipId]);

    const confirmExternalModalDescription = (
        <List>
            <ListItemText
                primary={<LocalizeText tag="confirmExternalLinkModalText" />}
            ></ListItemText>
        </List>
    );

    const openBariumLink = (): void => {
        getBariumRequestMoreArenasURL(Number(membershipId)).finally(() => setShowExternalLinkModal("NONE"));
        setShowExternalLinkModal("LOADING");
    };

    return (
        <>
            <div data-testid="arena-root" className="contentWrapper">
                <Banner
                    title="arenaOffices"
                    subTitle="bannerArenaOffices"
                    imageStyle={{ objectPosition: "65% 35%" }}
                    image={`${process.env.PUBLIC_URL}/assets/images/representatives/arenaOffices.jpg`}
                />
                <TopBar
                    singleItem={<VKButton
                        size="small"
                        variant="outlined"
                        isLoading={showExternalLinkModal === "LOADING"}
                        disabled={showExternalLinkModal !== "NONE"}
                        onClick={() => setShowExternalLinkModal("SHOW_MODAL")} >
                        <LocalizeText tag="requestNewArenas" />
                    </VKButton>}
                />

                <ArenaTable
                    onDrawerOpen={(type, arena) => {
                        setDrawerType(type);
                        setSelectedArenaId(arena.uuid);
                    }}
                    pagination={pagination}
                    loading={pagination.query.isFetching}
                />
                {membership?.end_date && (
                    <LocalizeText tag="inactivMembershipSubscriptionInfo" styling={{ padding: "10px" }} />
                )}
                {selectedArena && (
                    <ArenaDrawerGroup
                        membershipId={Number(membershipId)}
                        drawerType={drawerType}
                        onDrawerClose={() => {
                            setDrawerType("");
                            setSelectedArenaId(undefined);
                        }}
                        arena={selectedArena}
                        pagination={pagination}
                    />
                )}
            </div>
            <ConfirmDialog
                open={showExternalLinkModal === "SHOW_MODAL"}
                title={<LocalizeText tag="confirmExternalLinkModalTitle" />}
                description={confirmExternalModalDescription}
                hideRejectButton={true}
                onReject={() => setShowExternalLinkModal("NONE")}
                onAccept={() => openBariumLink()}
                acceptTag={"ok"}
            />
        </>
    );
};

export default ArenaView;
